export const sharedRoutes = {
  NOT_FOUND: '/not-found',
  SITE_NOT_FOUND: '/site-not-found',
  LOGOUT: '/logout',
  LOGIN: '/login',
  UNVERIFIED: '/unverified',
  RESET_PASSWORD: '/reset-password',
};
